import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, inject, input, output } from '@angular/core';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { Observable } from 'rxjs';

import { AppFacade } from 'ish-core/facades/app.facade';
import { VariationOptionGroup } from 'ish-core/models/product-variation/variation-option-group.model';
import { DeviceType } from 'ish-core/models/viewtype/viewtype.types';

@Component({
  selector: 'ish-product-variation-select-enhanced',
  templateUrl: './product-variation-select-enhanced.component.html',
  styleUrls: ['./product-variation-select-enhanced.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, NgbDropdownModule, TranslateModule],
})
export class ProductVariationSelectEnhancedComponent implements OnInit {
  private appFacade = inject(AppFacade);

  readonly group = input.required<VariationOptionGroup>();
  readonly uuid = input<string>(undefined);
  readonly multipleOptions = input<boolean>(undefined);

  readonly changeOption = output<{
    group: string;
    value: string;
  }>();

  deviceType$: Observable<DeviceType>;

  ngOnInit() {
    this.deviceType$ = this.appFacade.deviceType$;
  }

  optionChange(group: string, value: string) {
    this.changeOption.emit({ group, value });
  }
}
